import dateUtils from "@/businesslogic/utils/dateUtils";
import {Anfrage} from "@/model/Anfrage";

export default function storeUtils(): any {
    const istNurVGV = (storeData: Anfrage) => {
        return storeData.ferienhaus.versicherungsumfang === "0002";
    };

    const istNurVHV = (storeData: Anfrage) => {
        return storeData.ferienhaus.versicherungsumfang === "0003";
    };

    const istVGVundVHV = (storeData: Anfrage) => {
        return storeData.ferienhaus.versicherungsumfang === "0001";
    };

    const enthaeltVHV = (storeData: Anfrage) => {
        return istNurVHV(storeData) || istVGVundVHV(storeData);
    };

    const enthaeltVGV = (storeData: Anfrage) => {
        return istNurVGV(storeData) || istVGVundVHV(storeData);
    };

    const istFerienwohnung = (storeData: Anfrage) => {
        return storeData.gebaeudedaten.immobilieArt === "2";
    };
    const istFerienhaus = (storeData: Anfrage) => {
        return storeData.gebaeudedaten.immobilieArt === "1";
    };

    const istEinfamilienhaus = (storeData: Anfrage) => {
        return storeData.gebaeudedaten.gebaeudetyp === "1";
    };

    const istMehrfamilienhaus = (storeData: Anfrage) => {
        return storeData.gebaeudedaten.gebaeudesubtyp === "mfh";
    };

    const istFhkVerkaufsprodukt = (storeData: Anfrage) => {
        return istProdukt(storeData, ["fh2024"]);
    };

    const istVhvVerkaufsprodukt = (storeData: Anfrage) => {
        return istProdukt(storeData, ["vhv2024"]);
    };

    function istPhotovoltaikVersicherungMoeglich(storeData: Anfrage) {
        return photovoltaikAlterVersicherbar(storeData) && pvLeistungVersicherbar(storeData);
    }

    function photovoltaikAlterVersicherbar(storeData: Anfrage) {
        const versicherungsbeginnJahr = dateUtils().splitDateString(storeData.tarifinformationen.versicherungsbeginn).jahr;
        const pvBaujahr = storeData.gebaeudedaten.photovoltaikBaujahr ? storeData.gebaeudedaten.photovoltaikBaujahr : 0;

        return versicherungsbeginnJahr - pvBaujahr <= 10;
    }

    function pvLeistungVersicherbar(storeData: Anfrage) {
        if (storeData.gebaeudedaten.gebaeudetyp && storeData.gebaeudedaten.photovoltaikLeistung) {
            return storeData.gebaeudedaten.photovoltaikLeistung <= 30;
        }

        return false;
    }

    const istProdukt = (storeData: Anfrage, produkte: string[]) => {
        for (const p of produkte) {
            if (storeData.verkaufsprodukt.toLowerCase() === p) {
                return true;
            }
        }
        return false;
    };

    const istWegGemeinschaftsSonderUndTeileigentum = (storeData: Anfrage) => {
        return storeData.gebaeudedaten.gebaeudetyp === "0004";
    };

    const istWegGemeinschaftseigentum = (storeData: Anfrage) => {
        return storeData.gebaeudedaten.gebaeudetyp === "0005";
    };

    const gebaeudetypIstWeg = (storeData: Anfrage) => {
        return istWegGemeinschaftseigentum(storeData) || istWegGemeinschaftsSonderUndTeileigentum(storeData);
    };

    const miteigentuemerTypIstWeg = (storeData: Anfrage) => {
        return storeData.gebaeudedaten?.miteigentuemerTyp &&
            storeData.gebaeudedaten.miteigentuemerTyp === "WEG";
    }

    const miteigentuemerTypIstEtg = (storeData: Anfrage) => {
        return storeData.gebaeudedaten?.miteigentuemerTyp &&
        storeData.gebaeudedaten.miteigentuemerTyp === "ETG";
    }

    const miteigentuemerTypIstEhe = (storeData: Anfrage) => {
        return storeData.gebaeudedaten?.miteigentuemerTyp &&
        storeData.gebaeudedaten.miteigentuemerTyp.toUpperCase() === "EHE";
    }

    const istAlleineigentuemer = (storeData: Anfrage) => {
        return storeData.gebaeudedaten.alleineigentuemer === true;
    }

    const isUnbebautesGrundstueck = (storeData: Anfrage) => {
        return storeData.gebaeudedaten.unbebautesGruendstueck === true;
    }

    return {
        istNurVGV,
        istNurVHV,
        istVGVundVHV,
        enthaeltVHV,
        enthaeltVGV,
        istFerienhaus,
        istEinfamilienhaus,
        istMehrfamilienhaus,
        istFerienwohnung,
        istPhotovoltaikVersicherungMoeglich,
        photovoltaikAlterVersicherbar,
        pvLeistungVersicherbar,
        istFhkVerkaufsprodukt,
        istVhvVerkaufsprodukt,
        istProdukt,
        gebaeudetypIstWeg,
        miteigentuemerTypIstWeg,
        miteigentuemerTypIstEtg,
        miteigentuemerTypIstEhe,
        istAlleineigentuemer,
        isUnbebautesGrundstueck
    };
}
